// Shared option lists used across onboarding, filters and profile editing.

export const REGIONS = ["Southeast Asia", "Europe", "South America", "Central America", "East Asia", "Middle East", "Africa", "Oceania", "North America", "Central Asia"];

export const ACTIVITIES = [
  "Trekking & Hiking", "Rock Climbing", "Surfing", "Scuba Diving & Snorkelling",
  "Skiing & Snowboarding", "Cycling & Bikepacking", "Wild Swimming", "Safari & Wildlife",
  "Museums & Galleries", "Architecture & History", "Local Markets", "Street Art",
  "Religious Sites & Temples", "Off-the-Beaten-Path",
  "Street Food & Local Eats", "Fine Dining", "Craft Beer & Wine", "Nightlife & Clubs",
  "Cooking Classes", "Coffee Culture",
  "Budget Backpacking", "Slow Travel", "Road Trips & Van Life", "Volunteering & Community",
  "Photography & Content", "Wellness & Yoga Retreats",
];

export const ACCOMMODATIONS = ["Hostels (dorms)", "Hostels (private rooms)", "Guesthouses & B&Bs", "Budget hotels", "Airbnb / apartments", "Mid-range hotels", "Boutique & design hotels", "Camping & glamping", "Couchsurfing", "Whatever's cheapest"];

export const TRAVEL_SPEEDS = [
  { label: "Slow traveller", desc: "1–3 weeks per destination, really settle in" },
  { label: "Moderate pace", desc: "3–7 days per place, mix of depth and breadth" },
  { label: "Fast mover", desc: "1–3 days per stop, maximise places seen" },
  { label: "Flexible", desc: "Happy to adapt based on how a place feels" },
];

export const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export const YEARS = ["2025","2026","2027","2028"];
export const BUDGETS = ["< £25/day", "£25–50/day", "£50–100/day", "£100–200/day", "£200+/day"];
export const DURATIONS = ["1–2 weeks", "2–4 weeks", "1–3 months", "3–6 months", "6+ months"];
export const VIBES = ["Social & Party", "Relaxed", "Active", "Cultural", "Up for anything"];
export const GENDERS = ["Man", "Woman", "Non-binary", "Prefer not to say"];
export const LANGUAGES = ["English", "Spanish", "French", "German", "Italian", "Portuguese", "Mandarin", "Japanese", "Korean", "Arabic", "Hindi", "Dutch", "Russian", "Swedish", "Danish", "Finnish", "Norwegian", "Polish", "Turkish", "Greek"];
